import { I18n } from '@calendly/i18n';
import { Cell, Row } from '@calendly/table';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { trackEditorOpen, useEventTypeEditorSidebar } from 'features/event_type_editor';
import { useTrack } from 'hooks/analytics_events/useTrack';
import { isAdminOrOwnerSelector, isOnlyGroupAdminSelector } from 'selectors/current_user';
import { ActionsMenu } from './actions_menu';
import { useManagedEventTypeContext } from './managed_event_types_data';
const markerCss = "m5fmo7f";
const Marker = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    color,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  const style = {
    backgroundColor: color
  };
  return <Component ref={ref} {...restProps} style={style} data-component="marker" className={classNames(markerCss, props.className)} />;
});
const nameWrapperCss = "nhgme3f";
const NameWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(nameWrapperCss, props.className)} />;
});
const noWrapCss = "nin4h2u";
const NoWrap = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(noWrapCss, props.className)} />;
});
const AssignTo = () => {
  const {
    assignedOrganizationMembershipsCount: peopleCount,
    assignedUserGroups: userGroups
  } = useManagedEventTypeContext();
  if (userGroups.length + peopleCount === 0) {
    return <BodyText color="muted">
        <em>{I18n.t('publisher.organization.managed_event_types.table.assigned_to.none')}</em>
      </BodyText>;
  }
  return <>
      {userGroups.map(({
      id,
      name
    }) => <p key={id}>{name}</p>)}
      {peopleCount > 0 && I18n.t('publisher.organization.managed_event_types.table.assigned_to.people', {
      count: peopleCount
    })}
    </>;
};
export const ManagedEventTypesRow = ({
  disabled
}) => {
  const {
    id,
    name,
    color,
    type,
    kind,
    poolingType,
    kindDescription,
    owningUserGroup,
    briefUpdatedAt: lastUpdateDate
  } = useManagedEventTypeContext();
  const track = useTrack();
  const isAdminOrOwner = useSelector(isAdminOrOwnerSelector);
  const isOnlyGroupAdmin = useSelector(isOnlyGroupAdminSelector);
  const {
    id: openedEventTypeId,
    openSidebar: openEventTypeSidebar,
    isOpen: isETEditorOpen
  } = useEventTypeEditorSidebar();
  const canEdit = isAdminOrOwner || isOnlyGroupAdmin && !!owningUserGroup;
  const allowedToEdit = canEdit && !disabled;
  const isManagedEventTypeOpened = isETEditorOpen && String(id) === String(openedEventTypeId);
  const openSidebarEditor = () => {
    if (isManagedEventTypeOpened) return;
    openEventTypeSidebar({
      id,
      type,
      ownerType: 'Organization',
      kind,
      poolingType
    });
  };
  const trackEditMETV3 = () => {
    const etKind = kind || 'solo';
    trackEditorOpen({
      track,
      destination: 'edit',
      metRelationship: 'parent',
      source: 'admin center managed et card',
      kind: etKind,
      type: 'ManagedEventType',
      id
    });
  };
  const handleEdit = () => {
    if (!allowedToEdit) return;
    openSidebarEditor();
    trackEditMETV3();
  };
  return <Row onClick={handleEdit} highlighted={isManagedEventTypeOpened}>
      <Cell label={I18n.t('publisher.organization.managed_event_types.table.headers.name')}>
        <NameWrapper>
          <Marker color={color} />
          <BodyText weight="bold" inline>{name}</BodyText>
        </NameWrapper>
      </Cell>
      <Cell label={I18n.t('publisher.organization.managed_event_types.table.headers.type')}><NoWrap>{kindDescription}</NoWrap></Cell>
      <Cell label={I18n.t('publisher.organization.managed_event_types.owned_by')}>
        {owningUserGroup?.name || <NoWrap>{I18n.t('publisher.organization.managed_event_types.organization')}</NoWrap>}
      </Cell>
      <Cell label={I18n.t('publisher.organization.managed_event_types.table.headers.assigned_to')}>
        <AssignTo />
      </Cell>
      <Cell label={I18n.t('publisher.organization.managed_event_types.table.headers.date_last_edited')}>
        <NoWrap>{lastUpdateDate}</NoWrap>
      </Cell>
      <Cell hasActions>
        <ActionsMenu onEdit={handleEdit} />
      </Cell>
    </Row>;
};

require("./managed_event_types_row.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./managed_event_types_row.js");